import React from "react";
import {
  BlockText,
  BlockFigure,
  RecipeBoard,
  RecipeRow,
  RecipeCell,
  blockSectionBodyWrapClass,
} from "../../../designSystem/projectBlocks";

export const meta = {
  slug: "on-blocks",
  title: "On blocks.",
  summary:
    "How the projectBlocks system makes case-study pages cheap to maintain and visually consistent.",
  date: "2026-04-12",
  tags: ["design system", "process"],
};

export default function Entry() {
  return (
    <>
      <BlockText
        className={blockSectionBodyWrapClass}
        paragraphs={[
          "Every case study on this site renders through the same set of primitives: a compact hero, a 12-column grid, four canonical aspect ratios, and a five-role type ramp. The system has fewer moving parts than the pages it builds — which is the point.",
          "The bet is that once the shell is right, every new page is just composition. No hand-tuned margins, no per-page typography tweaks, no carousels. Below: one of the project pages, rendered with nothing this entry does not also have access to.",
        ]}
      />

      <RecipeBoard>
        <RecipeRow>
          <RecipeCell span={12} className="!p-0 !border-r-0">
            <BlockFigure
              src="/projects/SILTMiddelkerke/images/Frame_0.png"
              alt="SILT Middelkerke — example case-study render"
              ratio="banner"
              fit="cover"
              caption="SILT Middelkerke · banner figure"
            />
          </RecipeCell>
        </RecipeRow>
      </RecipeBoard>

      <BlockText
        className={blockSectionBodyWrapClass}
        paragraphs={[
          "The same BlockFigure that drives that banner powers every image in this writing. The same RecipeRow that lays out the project pages can lay out a 6 + 6 diptych in an entry about anything. That is what I mean when I say the writing is not a markdown island — it really is the portfolio, with prose.",
        ]}
      />
    </>
  );
}
